module.exports = __webpack_public_path__ + "img/my-mailouts-end.4a106666.svg";